import clsx from 'clsx';

interface FlyerPortraitSingleSidedProps {
  className?: string;
}

const FlyerPortraitSingleSided: React.FC<FlyerPortraitSingleSidedProps> = ({ className }) => {
  return (
    <svg
      className={clsx('flyer-portrait-single-sided', className)}
      fill="none"
      height="144"
      viewBox="0 0 116 144"
      width="116"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.5H108C112.142 0.5 115.5 3.85786 115.5 8V136C115.5 140.142 112.142 143.5 108 143.5H8C3.85787 143.5 0.5 140.142 0.5 136V8C0.500002 3.85787 3.85787 0.5 8 0.5Z"
        fill="white"
      />
      <path
        d="M8 0.5H108C112.142 0.5 115.5 3.85786 115.5 8V136C115.5 140.142 112.142 143.5 108 143.5H8C3.85787 143.5 0.5 140.142 0.5 136V8C0.500002 3.85787 3.85787 0.5 8 0.5Z"
        stroke="#D1D2D4"
      />
      <path d="M8 8H108V120C108 128.837 100.837 136 92 136H8V8Z" fill="#D1E7DD" />
      <g clipPath="url(#clip0_12824_13872)">
        <path
          d="M92 120C98.1262 121.327 101.62 121.455 108 120V136H92C92.8402 129.628 92.9094 126.117 92 120Z"
          fill="#A3CFBB"
        />
      </g>
      <path
        d="M67 66.75V81C67 82.6569 65.6569 84 64 84H52C50.3431 84 49 82.6569 49 81V63C49 61.3431 50.3431 60 52 60H60.25L67 66.75ZM62.5 66.75C61.2574 66.75 60.25 65.7426 60.25 64.5V61.5H52C51.1716 61.5 50.5 62.1716 50.5 63V81C50.5 81.8284 51.1716 82.5 52 82.5H64C64.8284 82.5 65.5 81.8284 65.5 81V66.75H62.5Z"
        fill="#75B798"
      />
      <defs>
        <clipPath id="clip0_12824_13872">
          <path d="M92 120H108C108 128.837 100.837 136 92 136V120Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


export default FlyerPortraitSingleSided;
